export const SDK_VERSION = '3.2362.20';